import React, { Component } from 'react';
import { Redirect } from 'react-router-dom';
import { PostData } from '../../services/PostData';
import { GetData } from '../../services/GetData';
import {
	Row,
	Col,
	Button,
	ButtonDropdown,
	DropdownToggle,
	DropdownMenu,
	DropdownItem,
	Card,
	CardHeader,
	CardFooter,
	CardBody,
	Collapse,
	Form,
	FormGroup,
	FormText,
	Label,
	Input,
	InputGroup,
	InputGroupAddon,
	InputGroupText,
	Table
} from 'reactstrap';
import $ from 'jquery';
import AcademicPage from '../../views/AcademicPage/';

const GLOBAL = require('../../Globals');

class AddSection extends Component {

	/** set property value **/
	constructor(props) {
		super(props);
		this.state = {
			id: '',
			cls: '',
			sects: '',
			acyear: '',
			secstatus: '',
			_message: '',
			alertClass: '',
			posts: [],
			secs: [],
			accyear: [],
			data: [],
			chksec: [],
			section: [],
			resection: [],
			stud: [],
			_redirect: false,
			chk: '',
			teach: []
		}

		this.onChange = this.onChange.bind(this);
		this.onChangeAlert = this.onChangeAlert.bind(this);
		this.onTeaChangeAlert = this.onTeaChangeAlert.bind(this);
	}

	onChangeAlert() {

		alert('Student Available in this Section');
	}

	onTeaChangeAlert() {

		alert('Class Teacher Allocate in this Section');
	}

	handleUnChange(id, sect, e) {
		this.state.cls = id;
		this.state.sects = sect;

		if (e.target.checked) {

			this.state.chk = '1';
			this.value = {
				acyear: this.state.acyear,
				cls: id,
				sects: sect,
				chk: '1'
			}
			if (sect == 1) {

				if (this.state.acyear && this.state.cls && this.state.sects) {
					$("#showLoader").show();
					PostData('section/addsection', this.value).then((result) => {
						$("#showLoader").hide();
						let responseJson = result;
						if (responseJson.status == '1') {
							this.getdata();
						}
						else {

							this.setState({
								_message: 'Already Added',
								alertClass: 'alert alert-danger'
							});
							document.getElementById("subform").reset();
						}
					});
				}
			}
			else {

				var f = document.getElementById("fdgfdg" + id + (sect - 1)).checked;

				if (f) {

					if (this.state.acyear && this.state.cls && this.state.sects) {
						$("#showLoader").show();
						PostData('section/addsection', this.value).then((result) => {
							$("#showLoader").hide();
							let responseJson = result;
							if (responseJson.status == '1') {
								this.getdata();
								// alert('Success!...');
							}
							else {

								this.setState({
									_message: 'Already Added',
									alertClass: 'alert alert-danger'
								});
								document.getElementById("subform").reset();
							}
						});
					}
				}
				else {

					document.getElementById("fdgfdg" + id + (sect)).checked = false;

					alert('Please Select Previous Section');
				}
			}
		}
		else {

			this.state.chk = '0';
			this.value = {
				acyear: this.state.acyear,
				cls: id,
				sects: sect,
				chk: '0'
			}
			if (sect == 10) {

				if (this.state.acyear && this.state.cls && this.state.sects) {
					$("#showLoader").show();
					PostData('section/addsection', this.value).then((result) => {
						$("#showLoader").hide();
						let responseJson = result;
						if (responseJson.status == '1') {
							this.getdata();
							// alert('Success!...');
						}
						else {

							this.setState({
								_message: 'Already Added',
								alertClass: 'alert alert-danger'
							});
							document.getElementById("subform").reset();
						}
					});
				}
			}
			else {

				var f = document.getElementById("fdgfdg" + id + (sect + 1)).checked;

				if (f) {

					document.getElementById("fdgfdg" + id + (sect)).checked = true;

					alert('In between section does not be removed');

				}
				else {

					if (this.state.acyear && this.state.cls && this.state.sects) {
						$("#showLoader").show();
						PostData('section/addsection', this.value).then((result) => {
							$("#showLoader").hide();
							let responseJson = result;
							// console.log(responseJson);
							if (responseJson.status == '1') {
								this.getdata();
								// alert('Success!...');
							}
							else {

								this.setState({
									_message: 'Already Added',
									alertClass: 'alert alert-danger'
								});
								document.getElementById("subform").reset();
							}
						});
					}
				}
			}
		}

	}

	/* handleChange(id,sect,e){
		
		if(e.target.checked){
			var index = this.state.section.findIndex(function(objstr){
			var obj=JSON.parse(objstr);
			return (obj.clas == id && obj.sec == sect); });
			
			if(index === -1){ 
				this.state.section.push('{"clas":'+id+', "sec":'+sect+'}');
			}
		}
		else{
		
			for(var i=0; i<this.state.section.length; i++){
				
				var obj=JSON.parse(this.state.section[i]);
			
				if( (obj.clas == id) && (obj.sec == sect)){
					
					this.state.section.splice(i,1);
					break;
				}
			}
		}
		console.log('add '+this.state.section);
	} */

	onChange(e) {

		$(".chkSec").prop("checked", false);
		this.forceUpdate();
		this.state.acyear = e.target.value;
		this.setState({ acyear: e.target.value, data: [], stud: [], teach: [] });
		this.getclass();
		this.getsection();
		this.getdata();
		this.getstddetails();
		this.getteadetails();

	}

	componentWillMount() {

		this.getacyear();
	}

	/** Get Allocated Section Data **/
	getdata() {
		var ac = this.state.acyear;
		$("#showLoader").show();
		$(".chkSec").prop("checked", false);
		this.setState({ data: [] });
		GetData('section/getsecbyacyear/' + ac).then((result) => {
			let responseJson = result;
			if (responseJson) {
				this.setState({
					data: responseJson
				});
				$("#showLoader").hide();
			}
		});
	}

	/** Get Class **/
	getclass() {

		GetData('classs/getclass').then((result) => {
			let responseJson = result;
			if (responseJson) {
				this.setState({
					posts: responseJson
				});
			}
		});
	}

	/** get Section **/
	getsection() {

		GetData('section/getsection').then((result) => {
			let responseJson = result;
			if (responseJson) {
				this.setState({
					secs: responseJson
				});
			}
		});
	}

	/** get Academic Year **/
	getacyear() {

		GetData('academic/getacyear').then((result) => {
			let responseJson = result;
			if (responseJson) {
				this.setState({
					accyear: responseJson
				});
				var index = responseJson.findIndex(function (obj) {
					return (obj.iscurrent == 1);
				});
				var academic = $("#year").find("option:eq(1)").val();
				this.setState({
					acyear: responseJson[index].id
				});
				$('#year option').eq(index + 1).prop('selected', true).trigger('change');
				this.getdata();
				this.getclass();
				this.getsection();
				this.getstddetails();
				this.getteadetails();
			}
		});
	}

	/** get Student Details using Check Section **/
	getstddetails() {
		var ac = this.state.acyear;
		$("#showLoader").show();
		GetData('student/getstdbyac/' + ac).then((result) => {
			$("#showLoader").hide();
			let responseJson = result;
			if (responseJson) {
				this.setState({
					stud: responseJson
				});
			}
		});
	}

	/** get Class Teacher Allocation Details using Check Section **/
	getteadetails() {
		var ac = this.state.acyear;
		$("#showLoader").show();
		GetData('teacherallocation/getdetails/' + ac).then((result) => {
			$("#showLoader").hide();
			let responseJson = result;
			if (responseJson) {
				this.setState({
					teach: responseJson
				});
			}
		});
	}

	getcheck(id) {

		var formFields = [];

		for (var i = 1; i < 11; i++) {

			// Check Allocated Section
			if (this.getclssec(id, i)) {

				//Check Class Teacher In this section
				if (this.checkclstea(id, i)) {

					formFields.push(<td><input type="checkbox" className="chkSec" id={"fdgfdg" + id + (i)} checked onClick={this.onTeaChangeAlert} /></td>);
				}
				else {

					//Check Student In this Section
					if (this.checksection(id, i)) {

						formFields.push(<td><input type="checkbox" className="chkSec" id={"fdgfdg" + id + (i)} checked onClick={this.onChangeAlert} /></td>);
					}
					else {
						formFields.push(<td><input type="checkbox" className="chkSec" id={"fdgfdg" + id + (i)} checked onClick={this.handleUnChange.bind(this, id, i)} /></td>);
					}
				}
			}
			else {

				formFields.push(<td><input type="checkbox" className="chkSec" id={"fdgfdg" + id + (i)} onClick={this.handleUnChange.bind(this, id, i)} /></td>);
			}
		}

		return (formFields);
	}

	// Check Section By Student Allocation
	checksection(cls, sec) {

		var bstate = false;
		for (var ii = 0; ii < this.state.stud.length; ii++) {

			if (this.state.stud[ii].class == cls && this.state.stud[ii].section == sec) {

				bstate = true;
				break;
			}
			else {
				bstate = false;
			}

		}
		return bstate;
	}

	// Check Section By Teacher Allocation
	checkclstea(cls, sec) {

		var teastate = false;
		for (var j = 0; j < this.state.teach.length; j++) {

			if (this.state.teach[j].clas == cls && this.state.teach[j].section == sec) {

				teastate = true;
				break;
			}
			else {
				teastate = false;
			}

		}
		return teastate;
	}

	getclssec(cls, sec) {

		var boolstate = false;
		for (var k = 0; k < this.state.data.length; k++) {

			if (this.state.data[k].clas == cls && this.state.data[k].section == sec) {

				boolstate = true;
				break;
			}
			else {
				boolstate = false;
			}

		}
		return boolstate;
	}

	render() {

		if (this.state._redirect) {

			return (<Redirect to={'/academic/updatesection/' + this.state.idd} />);

		}

		if (this.state.acyear != '') {

			// this.getdata(this.state.acyear);
			$("#sectable").show();
			$("#secbody").show();
		}
		else {

			$("#sectable").hide();
			$("#secbody").hide();
		}

		/** set status select box **/
		this.acyearstatus = [
			{ value: '', name: 'Select' },
			{ value: 'Active', name: 'Active' },
			{ value: 'Deactive', name: 'Deactive' }
		];

		var items = this.state.posts;
		var sec = this.state.secs;
		var acyear = this.state.accyear;

		return (
			<div>
				<AcademicPage />
				<div className="animated fadeIn">
					<div className={this.state.alertClass}>
						{this.state._message}
					</div>
					<Row>
						<Col md="12">
							<Card>
								<form action="" method="post" role="form" id="subform" encType="multipart/form-data" onSubmit={this.onSubmit} >
									<CardHeader>
										<strong>Add Section</strong>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
										Academic Year : &nbsp;&nbsp;
							<select name="acyear" onChange={this.onChange} required id="year">
											<option value="">Select Academic Year</option>
											{
												acyear.map(function (item) {
													return <option value={item.id}>{item.value}</option>;
												})
											}
										</select>
									</CardHeader>
									<CardBody id="secbody">
										<Row>
											<Col md="12">
												<Table responsive bordered id="sectable">
													<thead>
														<tr>
															<td>#</td>
															{this.state.secs.map(item =>

																<td>{item.section}</td>
															)}
														</tr>
													</thead>
													<tbody>
														{this.state.posts.map((item, index) =>
															<tr key={index}>
																<td>{item.class}</td>
																{this.getcheck(item.id)}
															</tr>
														)}
													</tbody>
												</Table>
											</Col>
										</Row>
									</CardBody>
								</form>
							</Card>
						</Col>
					</Row>
				</div>
			</div>
		)
	}
}

export default AddSection;


// WEBPACK FOOTER //
// ./src/academic/AddSection/AddSection.js